import { Phrases as PSGuiPhrases } from 'ps-gui';

import l10nCZ from './l10n/phrases_cz';
import l10nEN from './l10n/phrases_en';

let phrases = {};
let columnTexts = {};

function toCamelCase(value) {
	if (!value) {
		return '';
	}
	return value.split(/_/g).filter(str => !!str).map((str, index) => {
		if (index === 0) {
			return str;
		} else {
			return str.charAt(0).toUpperCase() + str.substring(1);
		}
	}).join('');
}

function camelify(obj) {
	for (let key in obj) {
		if (Object.getOwnPropertyDescriptor(obj, key)) {
			const camelKey = toCamelCase(key);
			if (camelKey !== key) {
				obj[camelKey] = obj[key];
			}
		}
	}
	return obj;
}

export function getPhrase(phraseId) {
	return phrases[phraseId] || phraseId;
}

export function getNumPhrase(phraseId, value) {
	let res = phrases[phraseId + '.' + value];
	if (!res) {
		res = getPhrase(phraseId + '.x');
	}
	if (!res) {
		res = getPhrase(phraseId);
	}
	return res;
}

export function getColumnText(colName, entityName, preferShort) {
	let res;
	if (preferShort) {
		res = columnTexts[entityName + '.' + colName + '.short'] || columnTexts[colName + '.short'];
	}
	if (!res) {
		res = columnTexts[colName + '.' + entityName] || columnTexts[colName];
	}
	return res || colName;
}

export function getFormItemLabel(colName, entityName) {
	return columnTexts[colName + '.form'] || columnTexts[colName + '.' + entityName] || columnTexts[colName] || colName;
}

function setL10n(l10n) {
	columnTexts = camelify(l10n.columnTexts);
	phrases = camelify(l10n.phrases);
}

setL10n(l10nCZ);

PSGuiPhrases.initializePhrases({
	getPhrase,
	getColumnText,
	getFormItemLabel,
	getIconHint: getPhrase
});

export function setPhraseLanguage(value) {
	if (value === 'EN') {
		setL10n(l10nEN);
	} else {
		setL10n(l10nCZ);
	}
}

export function getColumnTextMap(cols, entityName) {
	let res = {};
	cols.forEach(col => {
		res[col] = getColumnText(col, entityName);
	});
	return res;
}

window.dumpMissingPhrases = function () {
/*	let source = {
		columnTexts: l10nCZ.columnTexts,
		phrases: l10nCZ.phrases
	};
	let target = {};*/
	let source = l10nCZ;
	let target = l10nEN;

	let res = [];
	res.push('----- fraze ---');

	const koza = function (source, target) {
		if (!source) {
			return;
		}
		target = target || {};
		for (let key in source) {
			if (!target[key]) {
				res.push('\t\'' + key + '\': \'\', // ' + (source[key] || '').replace(/\n/g, '\\n'));
				// res.push(key + '\t\t' + source[key]);
			}
		}
	};

	for (let type in source) {
		res.push('\n// -------------- ' + type);
		koza(source[type], target[type]);
	}

	console.log(res.join('\n'));
};
